import { initials } from '../lib/format'

/**
 * De omlijnde cirkel met de initialen van het paar: "L&S". Komt terug op de
 * landing (68px), op desktop (78px), in de kop van het album (34px) en in de
 * zijnavigatie (40px), dus de maat is een parameter.
 */
export function Monogram({ coupleNames, size = 34 }: { coupleNames: string; size?: number }) {
  return (
    <span
      aria-hidden="true"
      style={{ width: size, height: size, fontSize: Math.round(size * 0.42) }}
      className="border-line bg-shell font-display text-accent flex shrink-0 items-center justify-center rounded-full border tracking-[0.04em]"
    >
      {initials(coupleNames)}
    </span>
  )
}

/**
 * De gevulde cirkel met de initialen van de gast: "TM". Anders dan het
 * monogram is deze massief terracotta — zo is in één oogopslag te zien welke
 * van de twee jij bent.
 */
export function GuestAvatar({
  displayName,
  size = 36,
  ring = false,
}: {
  displayName: string
  size?: number
  ring?: boolean
}) {
  return (
    <span
      aria-hidden="true"
      style={{ width: size, height: size, fontSize: Math.round(size * 0.36) }}
      className={
        'bg-accent text-accent-ink flex shrink-0 items-center justify-center rounded-full font-semibold ' +
        (ring ? 'ring-tint ring-3' : '')
      }
    >
      {initials(displayName)}
    </span>
  )
}
